import { render, staticRenderFns } from "./hotelDynamic.vue?vue&type=template&id=4ed6c83f&scoped=true"
import script from "./hotelDynamic.vue?vue&type=script&lang=js"
export * from "./hotelDynamic.vue?vue&type=script&lang=js"
import style0 from "./hotelDynamic.vue?vue&type=style&index=0&id=4ed6c83f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed6c83f",
  null
  
)

export default component.exports